import userPool from './Userpool';

export function getCurrentUserEmail() {
  const user = userPool.getCurrentUser();
  if (!user) return null;
  let email = null;
  user.getSession((err, session) => {
    if (!err && session && session.isValid()) {
      const idToken = session.getIdToken();
      const payload = idToken.payload;
      email = payload.email || null;
    }
  });
  return email;
}
